import type { ReactNode } from 'react';
import { BuildRefreshGuardMount } from '../app-shell/buildRefreshGuard';
import { YstnjRtkObjectTreeProvider } from '../state/objectTree/ystnjRtkObjectTree';

type AppProvidersProps = {
  children: ReactNode;
};

export const AppProviders = ({ children }: AppProvidersProps) => (
  <YstnjRtkObjectTreeProvider>
    <BuildRefreshGuardMount />
    {children}
  </YstnjRtkObjectTreeProvider>
);
